var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.salesItems),function(item){return _c('li',[_c('router-link',{attrs:{"to":("/store/" + (_vm.store.id) + "/sales_item/" + (item.id))}},[_vm._v(_vm._s(item.name))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }